module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "TransferHelper",
	"sourceName": "contracts/levels/P2PSwapper.sol",
	"abi": [],
	"bytecode": "0x60566023600b82828239805160001a607314601657fe5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220c2bfa30f7c5d048beeb3277d1dee07f6c03815c5573a5bcf067f9f02d6da9d2364736f6c634300060c0033",
	"deployedBytecode": "0x73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220c2bfa30f7c5d048beeb3277d1dee07f6c03815c5573a5bcf067f9f02d6da9d2364736f6c634300060c0033",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/P2PSwapper.sol/TransferHelper.json
// module id = 1597
// module chunks = 0